<script lang="ts">
import VRuntimeTemplate from 'vue3-runtime-template'
import { OpportunityService } from '~/services/opportunity.service'
import { Opportunity } from '~/models/Opportunity'

export default {
    name: 'OpportunityLikeChip',
    components: { VRuntimeTemplate },
    props: {
        opportunityData: { type: Object, required: true },
        organizationData: { type: Object, required: true },
        fullText: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            opportunityService: null as OpportunityService,
        }
    },

    computed: {
        html() {
            return this.opportunityService.getOrganizationLikeChip(this.organizationData, this.fullText)
        },
    },
    watch: {
        opportunityData() {
            this.opportunityService = new OpportunityService(new Opportunity(this.opportunityData))
        },
    },
    beforeMount() {
        this.opportunityService = new OpportunityService(new Opportunity(this.opportunityData))
    },
    methods: {
    },
}
</script>

<template>
    <span class="mr-2">
        <VRuntimeTemplate :template="html" />
    </span>
</template>
